import { createAction, handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
import React from "react";

// actionType
const SET_BASIC_USER_INFO = 'registerInfo/SET_BASIC_USER_INFO';
const SET_HOST_BUSINESS_INFO = 'registerInfo/SET_HOST_BUSINESS_INFO';
const CHECK_FOR_BASIC_USER = 'registerInfo/CHECK_FOR_BASIC_USER';

const SET_SITEID = 'registerInfo/SET_SITEID';
const CHECK_SITEID_DUPLICATE = 'registerInfo/CHECK_SITEID_DUPLICATE';
const SET_PASSWORD = 'registerInfo/SET_PASSWORD';
const SET_PASSWORD_CHECK = 'registerInfo/SET_PASSWORD_CHECK';
const SET_PHONE = 'registerInfo/SET_PHONE';
const CHECK_PHONE_AUTH = 'registerInfo/CHECK_PHONE_AUTH';
const SET_TID = 'registerInfo/SET_TID';
const SET_NAME = 'registerInfo/SET_NAME';
const SET_EMAIL = 'registerInfo/SET_EMAIL';
const SET_EMAIL_FRONT = 'registerInfo/SET_EMAIL_FRONT';
const SET_EMAIL_BACK = 'registerInfo/SET_EMAIL_BACK';
const SET_EMAIL_SELECT = 'registerInfo/SET_EMAIL_SELECT';
const CHECK_VALID_EMAIL = 'registerInfo/CHECK_VALID_EMAIL';
const SET_COMPANYNAME = 'registerInfo/SET_COMPANYNAME';
const SET_CEO = 'registerInfo/SET_CEO';
const SET_BUSSINESSNUM = 'registerInfo/SET_BUSSINESSNUM';
const SET_POSTNUM = 'registerInfo/SET_POSTNUM';
const SET_BASICADDR = 'registerInfo/SET_BASICADDR';
const SET_DETAILADDR = 'registerInfo/SET_DETAILADDR';
const SET_MAINCATEGORY = 'registerInfo/SET_MAINCATEGORY';
const SET_MIDCATEGORY = 'registerInfo/SET_MIDCATEGORY';
const SET_SUBCATEGORY = 'registerInfo/SET_SUBCATEGORY';
const SET_HOSTTYPE = 'registerInfo/SET_HOSTTYPE';
const SET_HOSTID = 'registerInfo/SET_HOSTID';
const SET_AGREE_RECV_MMS = 'registerInfo/SET_AGREE_RECV_MMS';
const SET_AGREE_RECV_MAIL = 'registerInfo/SET_AGREE_RECV_MAIL';
const SET_AGREE_RECV_KAKAO = 'registerInfo/SET_AGREE_RECV_KAKAO';
const SET_RIVAL_COMPANY_URL = 'registerInfo/SET_RIVAL_COMPANY_URL';
const SET_RIVAL_COMPANY_URLS = 'registerInfo/SET_RIVAL_COMPANY_URLS';

const SET_BUSSINESSFILE = 'registerInfo/SET_BUSSINESSFILE';

// action creators
export const setBasicUserInfo = createAction(SET_BASIC_USER_INFO);
export const setHostBusinessInfo = createAction(SET_HOST_BUSINESS_INFO);
export const checkForBasicUser = createAction(CHECK_FOR_BASIC_USER);

export const setSiteId = createAction(SET_SITEID);
export const checkSiteIdDuplicate = createAction(CHECK_SITEID_DUPLICATE);
export const setPassword = createAction(SET_PASSWORD);
export const setPasswordCheck = createAction(SET_PASSWORD_CHECK);
export const setPhone = createAction(SET_PHONE);
export const checkPhoneAuth = createAction(CHECK_PHONE_AUTH);
export const setTid = createAction(SET_TID);
export const setName = createAction(SET_NAME);
export const setEmail = createAction(SET_EMAIL);
export const setEmailFront = createAction(SET_EMAIL_FRONT);
export const setEmailBack = createAction(SET_EMAIL_BACK);
export const setEmailSelect = createAction(SET_EMAIL_SELECT);
export const checkValidEmail = createAction(CHECK_VALID_EMAIL);
export const setCompanyName = createAction(SET_COMPANYNAME);
export const setCeo = createAction(SET_CEO);
export const setBussinessNum = createAction(SET_BUSSINESSNUM);
export const setPostNum = createAction(SET_POSTNUM);
export const setBasicAddr = createAction(SET_BASICADDR);
export const setDetailAddr = createAction(SET_DETAILADDR);
export const setMainCateID = createAction(SET_MAINCATEGORY);
export const setMidCateID = createAction(SET_MIDCATEGORY);
export const setSubCateID = createAction(SET_SUBCATEGORY);
export const setHostType = createAction(SET_HOSTTYPE);
export const setHostId = createAction(SET_HOSTID);
export const setAgreeRecvMms = createAction(SET_AGREE_RECV_MMS);
export const setAgreeRecvMail = createAction(SET_AGREE_RECV_MAIL);
export const setAgreeRecvKakao = createAction(SET_AGREE_RECV_KAKAO);
export const setRivalCompanyUrl = createAction(SET_RIVAL_COMPANY_URL);
export const setRivalCompanyUrls = createAction(SET_RIVAL_COMPANY_URLS);

export const setBussinessFile = createAction(SET_BUSSINESSFILE);

const initialState = Map({
    checkInfo: {
        idDuplicated: false,
        phoneAuth: false,
        emailValid : false,
    },

    registerInfo: {
        siteid: '',
        password: '',
        passwordCheck: '',
        phone : '',
        tid: '',
        name: '',
        email: '',
        emailFront: '',
        emailBack: '',
        emailSelect:'',
        companyName: '',
        CEO: '',
        bussinessNum: '',
        postNum: '',
        basicAddr: '',
        detailAddr: '',
        mainCategoryId: '',
        midCategoryId: '',
        subCategoryId: '',
        useSync: 'N',
        syncType: '',
        hostType: '',
        hostId: '',
        agreeRecvMms: '',
        agreeRecvMail: '',
        agreeRecvKakao: 'N',
    },
    businessFile: null,

    rivalCompanyUrl: 'https://',
    rivalCompanyUrls: [],
});

//reducer
export default handleActions({
    [SET_BASIC_USER_INFO]: (state, action) => {
        const userInfo = action.payload;

        const email = userInfo.email;
        let emailFront, emailBack = '';
        if (email) {
            let arr = email.split('@');
            if (arr.length === 2) {
                emailFront = arr[0];
                emailBack = arr[1];
            }
        }

        return state
            .setIn(['registerInfo', 'useSync'], userInfo.useSync)
            .setIn(['registerInfo', 'syncType'], userInfo.syncType)
            .setIn(['registerInfo', 'siteid'], userInfo.siteid)
            .setIn(['registerInfo', 'password'], userInfo.password)
            .setIn(['registerInfo', 'passwordCheck'], userInfo.password)
            .setIn(['registerInfo', 'email'], userInfo.email)
            .setIn(['registerInfo', 'emailFront'], emailFront)
            .setIn(['registerInfo', 'emailBack'], emailBack)
            .setIn(['registerInfo', 'phone'], userInfo.phone)
            .setIn(['registerInfo', 'name'], userInfo.name)
    },
    [CHECK_FOR_BASIC_USER]: (state, action) => {
        const checkInfo = action.payload;
        return state
            .setIn(['checkInfo', 'idDuplicated'], checkInfo.idDuplicated)
            .setIn(['checkInfo', 'phoneAuth'],    checkInfo.phoneAuth)
            .setIn(['checkInfo', 'emailValid'],   checkInfo.emailValid);
    },
    [SET_HOST_BUSINESS_INFO]: (state, action) => {
        const businessInfo = action.payload;
        return state
            .setIn(['registerInfo', 'hostType'], businessInfo.hostType)
            .setIn(['registerInfo', 'hostId'], businessInfo.hostId)
            .setIn(['registerInfo', 'companyName'], businessInfo.companyName)
            .setIn(['registerInfo', 'CEO'], businessInfo.CEO)
            .setIn(['registerInfo', 'bussinessNum'], businessInfo.bussinessNum)
            .setIn(['registerInfo', 'postNum'], businessInfo.postNum)
            .setIn(['registerInfo', 'basicAddr'], businessInfo.basicAddr)
            .setIn(['registerInfo', 'detailAddr'], businessInfo.detailAddr);
    },
    [SET_SITEID]: (state, action) => {
        const siteId = action.payload;
        return state.setIn(['registerInfo', 'siteid'], siteId);
    },
    [CHECK_SITEID_DUPLICATE]: (state, action) => {
        const check = action.payload;
        return state.setIn(['checkInfo', 'idDuplicated'], check);
    },
    [SET_PASSWORD]: (state, action) => {
        const password = action.payload;
        return state.setIn(['registerInfo', 'password'], password);
    },
    [SET_PASSWORD_CHECK]: (state, action) => {
        const passwordCheck = action.payload;
        return state.setIn(['registerInfo', 'passwordCheck'], passwordCheck);
    },
    [SET_PHONE]: (state, action) => {
        const phone = action.payload;
        return state.setIn(['registerInfo', 'phone'], phone);
    },
    [CHECK_PHONE_AUTH]: (state, action) => {
        const check = action.payload;
        return state.setIn(['checkInfo', 'phoneAuth'], check);
    },
    [SET_TID]: (state, action) => {
        const tid = action.payload;
        return state.setIn(['registerInfo', 'tid'], tid);
    },
    [SET_NAME]: (state, action) => {
        const name = action.payload;
        return state.setIn(['registerInfo', 'name'], name);
    },
    [SET_EMAIL]: (state, action) => {
        const email = action.payload;
        return state.setIn(['registerInfo', 'email'], email);
    },
    [SET_EMAIL_FRONT]: (state, action) => {
        const emailFront = action.payload;
        return state.setIn(['registerInfo', 'emailFront'], emailFront);
    },
    [SET_EMAIL_BACK]: (state, action) => {
        const emailBack = action.payload;
        return state.setIn(['registerInfo', 'emailBack'], emailBack);
    },
    [SET_EMAIL_SELECT]: (state, action) => {
        const emailSelect = action.payload;
        return state.setIn(['registerInfo', 'emailSelect'], emailSelect);
    },
    [CHECK_VALID_EMAIL]: (state, action) => {
        const check = action.payload;
        return state.setIn(['checkInfo', 'emailValid'], check);
    },
    [SET_COMPANYNAME]: (state, action) => {
        const companyName = action.payload;
        return state.setIn(['registerInfo', 'companyName'], companyName);
    },
    [SET_CEO]: (state, action) => {
        const CEO = action.payload;
        return state.setIn(['registerInfo', 'CEO'], CEO);
    },
    [SET_BUSSINESSNUM]: (state, action) => {
        const bussinessNum = action.payload;
        return state.setIn(['registerInfo', 'bussinessNum'], bussinessNum);
    },
    [SET_POSTNUM]: (state, action) => {
        const postNum = action.payload;
        return state.setIn(['registerInfo', 'postNum'], postNum);
    },
    [SET_BASICADDR]: (state, action) => {
        const basicAddr = action.payload;
        return state.setIn(['registerInfo', 'basicAddr'], basicAddr);
    },
    [SET_DETAILADDR]: (state, action) => {
        const detailAddr = action.payload;
        return state.setIn(['registerInfo', 'detailAddr'], detailAddr);
    },
    [SET_MAINCATEGORY]: (state, action) => {
        const mainCategoryId = action.payload;
        return state.setIn(['registerInfo', 'mainCategoryId'], mainCategoryId);
    },
    [SET_MIDCATEGORY]: (state, action) => {
        const midCategoryId = action.payload;
        return state.setIn(['registerInfo', 'midCategoryId'], midCategoryId);
    },
    [SET_SUBCATEGORY]: (state, action) => {
        const subCategoryId = action.payload;
        return state.setIn(['registerInfo', 'subCategoryId'], subCategoryId);
    },
    [SET_HOSTTYPE]: (state, action) => {
        const hostType = action.payload;
        return state.setIn(['registerInfo', 'hostType'], hostType);
    },
    [SET_HOSTID]: (state, action) => {
        const hostId = action.payload;
        return state.setIn(['registerInfo', 'hostId'], hostId);
    },
    [SET_AGREE_RECV_MMS]: (state, action) => {
        const agreeRecvMms = action.payload;
        return state.setIn(['registerInfo', 'agreeRecvMms'], agreeRecvMms);
    },
    [SET_AGREE_RECV_MAIL]: (state, action) => {
        const agreeRecvMail = action.payload;
        return state.setIn(['registerInfo', 'agreeRecvMail'], agreeRecvMail);
    },
    [SET_AGREE_RECV_KAKAO]: (state, action) => {
        const agreeRecvKakao = action.payload === 'Y' ? 'Y' : 'N';
        return state.setIn(['registerInfo', 'agreeRecvKakao'], agreeRecvKakao);
    },
    [SET_RIVAL_COMPANY_URL]: (state, action) => {
        const rivalCompanyUrl = action.payload;
        return state.set('rivalCompanyUrl', rivalCompanyUrl);
    },
    [SET_RIVAL_COMPANY_URLS]: (state, action) => {
        const array = action.payload;
        return state
            .set('rivalCompanyUrl', 'https://')
            .set('rivalCompanyUrls', array);
    },

    [SET_BUSSINESSFILE]: (state, action) => {
        const businessFile = action.payload;
        return state.set('businessFile', businessFile);
    },
}, initialState)
